// LICENSE_CODE ZON
'use strict'; /*jslint node:true, es6:true, react:true*/
var define;
var is_node = typeof module=='object' && module.exports;
if (is_node)
    define = require('../../../util/require_node.js').define(module, '..');
else
    define = self.define;
define(['/util/url.js', '/www/hola/pub/experiment_init'],
    (zurl, experiment_init)=>{
experiment_init = experiment_init.default;
const qs_o = ()=>zurl.qs_parse(location.search.substr(1), {safe: true});
const E = {};
const ultra_pages = ['/ultra', '/pricing/ultra'];
const plus_pages = ['/premium', '/pricing/premium', '/uninstall',
    '/premium_land', '/only_payment_form', '/pricing'];

E.is_refund_exp = ()=>{
    const ref = qs_o().ref||'';
    const ref_re = new RegExp('(refund_special_big_offer|refund_special_cta)');
    return ref_re.test(ref) || location.pathname=='/refund';
};

E.is_plus_page = ()=>{
    return location.search.includes('debug_plus') ||
        plus_pages.includes(location.pathname) ||
        location.pathname.indexOf('/pricing')==0 ||
        location.pathname.indexOf('/payment_help')==0 ||
        location.pathname.indexOf('/premium_land')==0 ||
        location.pathname.indexOf('/only_payment_form')==0;
};

E.is_ultra_page = ()=>ultra_pages.includes(location.pathname);

E.is_uninstall_page = ()=>{
    const ref = qs_o().ref||'';
    return location.pathname=='/uninstall' || ref=='be_ext_uninstall';
};

E.is_ni_get_hola = ()=>{
    const ref = qs_o().ref||'';
    return location.pathname=='/ni_get_hola' || ref.indexOf('afflp_ni')>-1;
};

E.is_annual_get_hola = ()=>{
    const ref = qs_o().ref||'';
    return location.pathname=='/get_hola_annual_subscriptions' ||
        ref.indexOf('afflp_annual')>-1;
};

E.is_ultra_flash_special = ()=>{
    const ref = qs_o().ref||'';
    return ref.indexOf('ultra_flash_special')>-1;
};

E.is_annual_promo = ()=>{
    const ref = qs_o().ref||'';
    const ref_re = new RegExp('(vpn_flash_sale|black_friday|social_signup|'
        +'products_page|plus_setup_page|refund|christmas|'
        +'hp_hola_premium|hp_hidden_offer|easter|download_page|'
        +'the_oscars_special|pride_special|'
        +'promo_stream_sports|get_hola_1y)');
    return ref_re.test(ref) ||
        ['verify', 'welcome', 'special_offer', 'last_call',
        'popular_welcome', 'trial_cycle_end', 'trial_cycle_end_4',
        'trial_cycle_end_5', 'vpn_conflict', 'hola_features',
        'billing', 'membership_renewal', 'upgrade_1',
        'win_premium_back', 'trial_cycle_end_1', 'trial_cycle_end_2',
        'trial_cycle_end_3', 'upgrade_2', 'upgrade_3', 'upgrade_4',
        'upgrade_5', 'ultra_reminder', 'premium_reminder',
        'trial_cycle_end_7', 'special_movie', 'special_sport',
        'special_live'].some(v=>
            ref.includes(`${v}_email`));
};

E.is_annual_promo_full = ()=>{
    return E.is_annual_promo();
};

E.is_bogof_promo = ()=>{
    const ref = qs_o().ref||'';
    const re = '(summer_special|olympic_games|school_special|'
        +'vpn_flash_monthly|we_love_summer|fall_promo|yesvember|'
        +'holiday_season)';
    return new RegExp(re).test(ref);
};

E.is_bogof_y_promo = ()=>{
    const ref = qs_o().ref||'';
    return /(valentine_23)/.test(ref);
};

E.is_kivoto_promo = ()=>{
    const ref = qs_o().ref||'';
    return /(get_hola_kivuto)/.test(ref);
};

E.is_march_madness_promo = ()=>{
    const ref = qs_o().ref||'';
    return /(march_madness|april_fool|spring_special|pride_month)/.test(ref);
};

E.is_march_madness_promo_full = ()=>{
    return E.is_march_madness_promo();
};

E.is_dunning_promo = ()=>{
    const ref = qs_o().ref||'';
    return /(dunning.*cancel)/.test(ref);
};

return E;
});
